import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { useMemo } from 'react';

import {
  StyledContainer,
  StyledRadioFormControl,
  StyledFormGroup,
  StyledSubTitle,
} from '@selfserve/react-ui';
import { billingCycles } from '@selfserve/react-utils';

import { PackageDetail } from '../data';
import { FormValues } from '../feature/build-your-plan';

interface Props extends PackageDetail {
  formik: FormikProps<FormValues>;
}

export const BillingCycle = ({
  formik: {
    values: { billingCycle },
    handleChange,
  },
  annually_headline,
  monthly_headline,
}: Props) => {
  const { t } = useTranslation();
  const isAnnually = useMemo(
    () => billingCycle === billingCycles.ANNUALLY,
    [billingCycle]
  );
  const isMonthly = useMemo(
    () => billingCycle === billingCycles.MONTHLY,
    [billingCycle]
  );

  return (
    <StyledContainer fitHeight>
      <StyledSubTitle className="sub-header ng-star-inserted" as="span">
        {t('common.billing-cycle')}
      </StyledSubTitle>
      <div className="billing-cycle-selection">
        <StyledFormGroup
          className={classNames('p-radiobutton p-component', {
            checked: isAnnually,
          })}
          rowWithLabel
          blackLabel
        >
          <StyledRadioFormControl
            id={billingCycles.ANNUALLY}
            name="billingCycle"
            value={billingCycles.ANNUALLY}
            checked={isAnnually}
            onChange={handleChange}
          />
          <label htmlFor={billingCycles.ANNUALLY}>
            {annually_headline || t('common.annually')}
          </label>
        </StyledFormGroup>
        <StyledFormGroup
          className={classNames('p-radiobutton p-component', {
            checked: isAnnually,
          })}
          rowWithLabel
          withoutMargin
          blackLabel
        >
          <StyledRadioFormControl
            id={billingCycles.MONTHLY}
            name="billingCycle"
            value={billingCycles.MONTHLY}
            checked={isMonthly}
            onChange={handleChange}
          />
          <label htmlFor={billingCycles.MONTHLY}>
            {monthly_headline || t('common.monthly')}
          </label>
        </StyledFormGroup>
      </div>
    </StyledContainer>
  );
};
